import styled from "styled-components"

const SubFolderHeading = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
`

export default SubFolderHeading
